const NOTIFICATION_SYNC_EVENT = "notification:user-state-updated";

export function emitNotificationUserStateUpdated(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new CustomEvent(NOTIFICATION_SYNC_EVENT));
}

export function subscribeNotificationUserStateUpdated(
  callback: () => void,
): () => void {
  if (typeof window === "undefined") {
    return () => {};
  }

  const listener = () => callback();
  window.addEventListener(NOTIFICATION_SYNC_EVENT, listener);
  return () => {
    window.removeEventListener(NOTIFICATION_SYNC_EVENT, listener);
  };
}
